import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export interface ExternalLinkModalData {
  popupdata: any;
  url?: string;
}

@Component({
    selector: 'app-external-link-modal',
    templateUrl: './external-link-modal.component.html',
    styleUrls: ['./external-link-modal.component.scss'],
    standalone: false
})
export class ExternalLinkModalComponent {
  constructor(
    private dialogRef: MatDialogRef<ExternalLinkModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExternalLinkModalData
  ) {}

  get popupdata(): any {
    return this.data?.popupdata;
  }

  onContinue(): void {
    const url = this.getSafeUrl(this.data?.url || this.popupdata?.link || '');
    if (url) {
      window.open(url, '_blank');
    }
    this.dialogRef.close();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getSafeUrl(url: string): string {
    if (url && url.trim().toLowerCase().startsWith('unsafe:')) {
      return url.trim().replace(/^unsafe:/i, '');
    }
    return url;
  }
}
